import SettingsMenuWrapper from '@/components/layout/SettingsMenuWrapper';
import { useNavigation } from '@/hooks/useNavigation';

interface SettingsScreenProps {
  onGoHome: () => void;
}

function SettingsScreen({ onGoHome }: SettingsScreenProps) {
  const { navigate } = useNavigation();

  const handleRestart = () => {
    // If we're in a game, restart it
    // For now, just navigate to game
    console.log('Restart game');
    navigate('/game');
  };

  const handleToggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <SettingsMenuWrapper
      isOpen={true} // Always open on this screen
      onClose={onGoHome}
      onRestart={handleRestart}
      onGoHome={onGoHome}
      onToggleFullscreen={handleToggleFullscreen}
    />
  );
}

export default SettingsScreen;